import { minutesToHours } from 'date-fns';

export default function formatDuration(minutes?: number | null) {
  if (minutes == null || Number.isNaN(minutes)) {
    return '--';
  }

  const hours = minutesToHours(minutes);

  const minutesRem = minutes - hours * 60;

  if (!hours) {
    return `${minutes}m`;
  }

  return `${hours}h ${minutesRem}m`;
}
